export default function(flatMainMenu, activeBasePath) {
  const found = flatMainMenu.find(
    item => item.route.basePath === activeBasePath && item.parentRoute,
  )
  return (found && found.parentRoute) || null
}
